import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/narka/";

export default class NARKAApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getNARKAs(params) {
    return await request.post(`${rootRoute}getNARKAs`, {
      filter: params,
      parameters: {},
    });
  }
  async getNARKA(id) {
    return await request.post(`${rootRoute}getNARKAs`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createNARKA(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createNARKA`, { data });
  }
  async deleteNARKA(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteNARKA`, { data });
  }
  async editNARKA(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateNARKA`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importNARKA`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getNARKAimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportNARKA`, {
      filter: filter,
      format: format
    });
  }
}
